/* eslint-disable react/no-unknown-property */
import { Button, Icon } from '@pypestream/design-system';
import { FC } from 'react';
import { useFileInput } from '../../hooks';

type UploadProps = {
  label: string;
  disabled?: boolean;
  'test-id'?: string;
  onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Upload: FC<UploadProps> = ({
  label,
  disabled,
  'test-id': testId,
  onUpload,
}) => {
  const { input, inputRef: fileInputRef } = useFileInput({
    'test-id': `${testId}-input`,
    disabled: disabled ?? false,
    accept: '.py',
    type: 'file',
    multiple: true,
    style: { display: 'none' },
    onChange: onUpload,
  });

  return (
    <>
      {input}
      <Button
        test-id={`${testId}-button`}
        size="large"
        variant="ghost"
        onClick={() => fileInputRef.current?.click()}
      >
        <Icon name="upload" slot="prefix" /> {label}
      </Button>
    </>
  );
};
